const manufacturing = [
  {
    path: '/manufacturing/dashboard',
    name: 'manufacturing-dashboard',
    component: () => import('@/views/manufacturing/dashboard/dashboard.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  // {
  //   path: '/manufacturing/mbom-list',
  //   name: 'mbom-list',
  //   component: () => import('@/views/manufacturing/mbom/List.vue'),
  //   meta: {
  //     layout: 'content',
  //     app: 'manufacturing',
  //     appId: 16,
  //   },
  // },
  {
    path: '/manufacturing/mbom/view/:uuid',
    name: 'mbom-details',
    component: () => import('@/views/manufacturing/mbom/Details.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/mbom/create',
    name: 'mbom-create',
    component: () => import('@/views/manufacturing/mbom/Create.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/mbom/edit/:uuid',
    name: 'mbom-edit',
    component: () => import('@/views/manufacturing/mbom/Create.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },

  {
    path: '/manufacturing/bill-of-materials',
    name: 'bill-of-materials',
    component: () => import('@/views/manufacturing/bill-of-materials/List.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/bill-of-materials/view/:uuid',
    name: 'bill-of-materials-details',
    component: () => import('@/views/manufacturing/bill-of-materials/Details.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/bill-of-materials/create',
    name: 'create-bill-of-materials',
    component: () => import('@/views/manufacturing/bill-of-materials/Create.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/bill-of-materials/edit/:uuid',
    name: 'bom-edit',
    component: () => import('@/views/manufacturing/bill-of-materials/Create.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/bill-of-materials/duplicate',
    name: 'bom-duplicate',
    component: () => import('@/views/manufacturing/bill-of-materials/Create.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/work-centers',
    name: 'work-centers',
    component: () => import('@/views/manufacturing/work-centers/List.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/work-centers/view/:uuid',
    name: 'work-centers-details',
    component: () => import('@/views/manufacturing/work-centers/Details.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/work-centers/create',
    name: 'create-work-centers',
    component: () => import('@/views/manufacturing/work-centers/Create.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/work-centers/edit/:uuid',
    name: 'work-centers-edit',
    component: () => import('@/views/manufacturing/work-centers/Create.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/work-center-overview',
    name: 'work-center-overview',
    component: () => import('@/views/manufacturing/work-center-overview/List.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },

  {
    path: '/manufacturing/work-center-overview/view/:category_id/:working_hours_id',
    name: 'work-center-details',
    component: () => import('@/views/manufacturing/work-center-overview/Details.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/manufacturing-order',
    name: 'manufacturing-order',
    component: () => import('@/views/manufacturing/manufacturing-order/List.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/manufacturing-order/view/:uuid',
    name: 'manufacturing-order-details',
    component: () => import('@/views/manufacturing/manufacturing-order/Details.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/manufacturing-order/create',
    name: 'create-manufacturing-order',
    component: () => import('@/views/manufacturing/manufacturing-order/Create.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/manufacturing-order/edit/:uuid',
    name: 'manufacturing-order-edit',
    component: () => import('@/views/manufacturing/manufacturing-order/Create.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },

  {
    path: '/manufacturing/group-manufacturing-order',
    name: 'group-manufacturing-order',
    component: () => import('@/views/manufacturing/group-manufacturing-order/List.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/group-manufacturing-order/view/:uuid',
    name: 'group-manufacturing-order-details',
    component: () => import('@/views/manufacturing/group-manufacturing-order/Details.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/group-manufacturing-order/create',
    name: 'create-group-manufacturing-order',
    component: () => import('@/views/manufacturing/group-manufacturing-order/Create.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/group-manufacturing-order/edit/:uuid',
    name: 'group-manufacturing-order-edit',
    component: () => import('@/views/manufacturing/group-manufacturing-order/Create.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/manufacturing-planning',
    name: 'manufacturing-planning',
    component: () => import('@/views/manufacturing/manufacturing-planning/List.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/manufacturing-planning/:uuid',
    name: 'manufacturing-planning-details',
    component: () => import('@/views/manufacturing/manufacturing-planning/Details.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/manufacturing-planning/create',
    name: 'create-manufacturing-planning',
    component: () => import('@/views/manufacturing/manufacturing-planning/Create.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/void',
    name: 'manufacturing-void',
    component: () => import('@/views/manufacturing/void/voidList.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/work-orders',
    name: 'manufacturing-work-orders',
    component: () => import('@/views/manufacturing/work-order/List.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/work-orders/view/:uuid',
    name: 'work-orders-details',
    component: () => import('@/views/manufacturing/work-order/Details.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/work-orders/:uuid/edit',
    name: 'work-orders-update',
    component: () => import('@/views/manufacturing/work-order/updateForm.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/:prop_type/import',
    name: 'manufacturing-import',
    component: () => import('@/components/inventory-management/common/InvImportExcelData.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/quality-form',
    name: 'manufacturing-quality-form',
    component: () => import('@/views/manufacturing/quality-form/FormsList.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/project-view',
    name: 'manufacturing-project-view',
    component: () => import('@/views/manufacturing/project-view/ListView.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/report/manufacturing',
    name: 'manufacturing-report',
    component: () => import('@/views/manufacturing/report/Manufacture.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/report/workcenter',
    name: 'workcenter-report',
    component: () => import('@/views/manufacturing/report/WorkcenterReport.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
  {
    path: '/manufacturing/report/userreport',
    name: 'user-report',
    component: () => import('@/views/manufacturing/report/UserReport.vue'),
    meta: {
      layout: 'content',
      app: 'manufacturing',
      appId: 16,
    },
  },
]

export default manufacturing
